"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCandid = exports.fromCandid = void 0;
function fromCandid(value) {
    return Array.isArray(value) && value.length
        ? value[0]
        : null;
}
exports.fromCandid = fromCandid;
function toCandid(value) {
    return value ? [value] : [];
}
exports.toCandid = toCandid;
